import { tableCheckboxVariant } from '../table/theme';
import { checkboxHelpers } from './utils';

export const checkboxTheme = checkboxHelpers.defineMultiStyleConfig({
  variants: { table: tableCheckboxVariant },
});
